import React, {ChangeEvent, FC} from 'react';
import {Field} from 'formik';
import {PERCENT_RATE} from '../../../../constants/timeProgressBar';

const DEFAULT_STEP = 1;

type RangeInputProps = {
  value: number,
  name: string,
  min: number,
  max: number,
  onChange: (e: ChangeEvent<HTMLInputElement>) => void,
  disabled?: boolean,
  step?: number
}

const RangeInput: FC<RangeInputProps> = ({
  value,
  name,
  min,
  max,
  onChange,
  disabled,
  step
}) => {
  const backgroundSize = (value - min) * PERCENT_RATE / (max - min);

  return (
    <Field
      type="range"
      name={name}
      id={name}
      max={max}
      min={min}
      step={step || DEFAULT_STEP}
      value={value}
      onChange={onChange}
      style={{backgroundSize: `${backgroundSize}% 100%`}}
      disabled={disabled}
    />
  );
};

export default RangeInput;
